export default "__VITE_ASSET__b1e96dd4__"